export default "__VITE_ASSET__CfqYDpKV__"